import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { GoogleIcon, FacebookIcon, AppleIcon } from './SocialIcons';
export const Register: React.FC = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, we would send registration data to the server
    // For now, we'll just navigate to verification page
    navigate('/verification', {
      state: {
        phoneNumber
      }
    });
  };
  return <div className="min-h-screen flex items-center justify-center bg-background p-4" data-id="element-350">
      <div className="w-full max-w-md" data-id="element-351">
        <div className="text-center mb-8" data-id="element-352">
          <h1 className="text-3xl font-bold text-primary" data-id="element-353">Divergram</h1>
          <p className="text-gray-600 mt-2" data-id="element-354">Create your account</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-gray-100" data-id="element-355">
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-356">
            <div className="grid grid-cols-2 gap-4" data-id="element-357">
              <div data-id="element-358">
                <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-359">
                  First Name
                </label>
                <input type="text" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="John" required data-id="element-360" />
              </div>
              <div data-id="element-361">
                <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-362">
                  Last Name
                </label>
                <input type="text" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="Doe" required data-id="element-363" />
              </div>
            </div>
            <div data-id="element-364">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-365">
                Email Address
              </label>
              <input type="email" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="your@email.com" required data-id="element-366" />
            </div>
            <div data-id="element-367">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-368">
                Mobile Phone
              </label>
              <input type="tel" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="+1 (555) 123-4567" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} required data-id="element-369" />
              <p className="text-xs text-gray-500 mt-1.5" data-id="element-370">
                We'll send a verification code to this number
              </p>
            </div>
            <div data-id="element-371">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-372">
                Password
              </label>
              <input type="password" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="••••••••" required data-id="element-373" />
            </div>
            <div data-id="element-374">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-375">
                Confirm Password
              </label>
              <input type="password" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="••••••••" required data-id="element-376" />
            </div>
            <div className="pt-2" data-id="element-377">
              <div className="flex items-center" data-id="element-378">
                <input id="terms" type="checkbox" className="w-4 h-4 text-primary focus:ring-primary/50 border-gray-300 rounded" required data-id="element-379" />
                <label htmlFor="terms" className="ml-2 text-sm text-gray-700" data-id="element-380">
                  I agree to the{' '}
                  <a href="#" className="text-primary hover:underline" data-id="element-381">
                    Terms of Service
                  </a>{' '}
                  and{' '}
                  <a href="#" className="text-primary hover:underline" data-id="element-382">
                    Privacy Policy
                  </a>
                </label>
              </div>
            </div>
            <Button type="submit" variant="primary" fullWidth size="lg" className="mt-6" data-id="element-383">
              Create Account
            </Button>
          </form>
          <div className="relative flex items-center justify-center my-6" data-id="element-384">
            <div className="border-t border-gray-300 absolute w-full" data-id="element-385"></div>
            <span className="bg-white px-2 text-sm text-gray-500 relative" data-id="element-386">
              Or sign up with
            </span>
          </div>
          <div className="grid grid-cols-3 gap-3" data-id="element-387">
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-388">
              <GoogleIcon data-id="element-389" />
            </Button>
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-390">
              <FacebookIcon data-id="element-391" />
            </Button>
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-392">
              <AppleIcon data-id="element-393" />
            </Button>
          </div>
        </div>
        <div className="text-center" data-id="element-394">
          <p className="text-gray-600" data-id="element-395">
            Already have an account?{' '}
            <Link to="/login" className="text-primary hover:underline font-medium" data-id="element-396">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>;
};